import { FC, ReactNode } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { RatePlanCharacteristics } from '@telialt/models/src/EshopModel';
import { isDefined } from '@telialt/utils/src/helpers';

import { PRODUCT_RATE_PLAN_SYMBOLS } from '../constants';

export const RatePlanTerms: FC<RatePlanCharacteristics & { className?: string }> = ({
    className,
    ...planCharacteristics
}) => {
    const Container: FC<{ children: ReactNode }> = ({ children }) => <span className={className}>{children}</span>;
    const { t } = useTranslations();

    const infSymbol = (
        <span aria-label={t['eshop.product_page.unlimited_accessible']}>
            <span aria-hidden={true}>&infin;</span>
        </span>
    );

    const { includedMinuteCount, includedSmsCount, dataAmount, dataAmountUnit } = planCharacteristics;
    const { MIN_SMS_GB, MIN_SMS, MIN, SMS } = PRODUCT_RATE_PLAN_SYMBOLS;

    const maybeDataAmountInf = dataAmount === -1 ? infSymbol : dataAmount;
    const maybeSmsAmountInf = includedSmsCount === -1 ? infSymbol : includedSmsCount;
    const maybeMinuteAmountInf = includedMinuteCount === -1 ? infSymbol : includedMinuteCount;

    if (includedMinuteCount === -1 && includedSmsCount === -1 && dataAmount === -1) {
        return (
            <Container>
                {infSymbol} {MIN_SMS_GB}
            </Container>
        );
    }
    if (includedMinuteCount === -1 && includedSmsCount === -1) {
        return (
            <Container>
                {infSymbol} {MIN_SMS}, {maybeDataAmountInf}&nbsp;{dataAmountUnit}
            </Container>
        );
    }

    return (
        <Container>
            {isDefined(includedMinuteCount) && (
                <>
                    {maybeMinuteAmountInf}&nbsp;{MIN},{' '}
                </>
            )}
            {isDefined(includedSmsCount) && (
                <>
                    {maybeSmsAmountInf}&nbsp;{SMS},{' '}
                </>
            )}
            {maybeDataAmountInf}&nbsp;
            {dataAmountUnit}
        </Container>
    );
};
